import { useField} from "@formiz/core";
import React from "react";
const FormInput = (props) => {
  const {
    errorMessage,
    id,
    isValid,
    isPristine,
    isSubmitted,
    resetKey,
    setValue,
    value,
  } = useField(props);
  const { label, type, required, placeholder } = props;
  const [isFocused, setIsFocused] = React.useState(false);
  const showError = !isValid && !isFocused && (!isPristine || isSubmitted);
  return (
    <div className={`formGroup formInput  ${showError ? "is-error" : ""}`}>
      <label className="styleLable" htmlFor={id}>
        {label}
        {required && " *"}
      </label>
      <input
        key={resetKey}
        id={id}
        type={type || "text"}
        value={value || ""}
        onChange={(e) => setValue(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        aria-invalid={!isValid}
        aria-describedby={!isValid ? `${id}-error` : null}
        placeholder={placeholder}
      />
      {showError && (
        <div id={`${id}-error`} className="error">
          {errorMessage}
        </div>
      )}
    </div>
  );
};
export default FormInput;
